import { hyperdbHandlers } from 'hyperdb-utils';

export default hyperdbHandlers({ namespace: 'RESERVATION' });



// WEBPACK FOOTER //
// ./src/frontend/modules/daily-rental/reservation/handlers.js